@if (label) {
<label
  [attr.for]="id"
  soho-label
    [required]="required$ | async"
  lm-label
    [layoutField] = "field"
    [personalize]="personalize"
  lm-text-style
    [textStyle]="field?.label?.textStyle"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>
}
<div
  lm-field-options
    [hasContextMenu]="insertContextMenu"
    [ajaxCallbackFunction]="onBeforeContextMenuOpen"
    [contextMenuEventFunction]="contextMenuClicked"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [buttonId]="fieldOptionsId"
    [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
    [isInAccessibilityMode]="isInAccessibilityMode"
    [displayFieldOptions]="displayFieldOptions"
    [disableFieldOptions]="disableFieldOptions"
    [fieldAutomationId]="fieldAutomationId"
  soho-tooltip
    [popover]="true"
    [title]="popoverTitle"
    [placement]="'bottom'"
    [trigger]="'click'"
  [ngClass]="{'lm-is-display-as-text': displayAsText}"
  (contextmenu)="onContextMenu($event)"
  (focusin)="onFieldFocus($event)"
  (focusout)="onFieldBlur($event)">
  @switch (displayType) {
    @case (layoutDisplayType.PLAIN) {
      <textarea
      #Input
      [ngClass]="fieldClassesString"
      [attr.id]="id"
      [attr.aria-label]="field?.label?.nolabel && bindId"
      [attr.tabindex]="isInAccessibilityMode ? 0 : (readOnly$ | async) ? -1 : null"
      [attr.bindId]="bindId"
      [attr.readonly]="(readOnly$ | async) ? true : null"
      [attr.aria-describedby]="fieldDescriptionId" 
      [(ngModel)]="modelField.value"
      lm-displayupper
        [isUpperCase]="isUpperCase"
      lm-field-style
        [specField]="specField"
        [fieldStyle]="layoutObject?.fieldStyle"
        [recalculateStyles]="triggerValueChange | async"
      soho-textarea
        [characterCounter]="false"
        [maxlength]="maxLength"
        [rows]="rows"
      soho-alert
      soho-trackdirty
        (dirty)="onDirty($event)"
        (pristine)="onPristine($event)"
        (afterResetDirty)="onAfterResetDirty($event)"
      soho-input-validate
        (error)="onError($event)"
        (valid)="onValid($event)"
      (blur)="onBlur($event)"
      (input)="onInput($event)"
    ></textarea>
    }
    @case (layoutDisplayType.DISPLAY_AS_TEXT) {
      <p
        [attr.id]="id"
        [ngClass]="fieldClassesString"
        [class.personalize-text]="personalize"
        [ngStyle]="{ '-webkit-line-clamp': layoutObject?.lines }"
        soho-alert
        lm-field-style
          [specField]="specField"
          [fieldStyle]="layoutObject?.fieldStyle"
          [recalculateStyles]="triggerValueChange | async"
    >{{modelField.valueChanged | async | formatMessageRule:true:field.text:model:specFields}}</p>
    }
  }
  @if (showBarCodeIcon) {
      <lm-scan-options
          [hasContextMenu]="false"
          [displayScanOptions]="false"
          (click)="onBarCodeClick()"
      ></lm-scan-options>
  }
</div>

<ng-template #mouseOverTextTemplate>
  @if (layoutObject.mouseOverText) {
    <lm-mouse-over-text [beforeShowTooltip]="displayMouseOverText"></lm-mouse-over-text>
  }
</ng-template>

<span [attr.id]="fieldDescriptionId" class="audible">{{ (isFocused$ | async) ? fieldDescription : '' }}</span>

@if (errorLiveMessage.liveMessage) {
  <span lm-live-region [liveRegionConfig]="errorLiveMessage"></span>
}